var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vix-modal',{attrs:{"show":_vm.show,"config":_vm.modalConfig}},[_c('p',[_vm._v(_vm._s(_vm.dialogConfig.detail))]),_c('div',{staticClass:"agreement"},[_vm._v("同意"),_c('span',{staticClass:"agreement-url",on:{"click":_vm.toAgreement}},[_vm._v(_vm._s(_vm.dialogConfig.agreement_name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }